<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br /> {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            I am sending this letter to you in response to a collection notice I received from you on <strong>{{ originalCreditedDate != null ? moment(originalCreditedDate).format('LL') : '(Insert Date)' }}</strong>. A copy
            is attached to this letter.
        </p>
        <p>
            Please be advised that this is not a refusal to pay, but a notice sent pursuant to the Fair Debt Collection Practices
            Act, 15 US Code § 1692g that your claim is disputed and validation is requested. I respectfully request that your
            offices provide me with competent evidence that I have any legal obligation to pay you regarding the following account
            number(s):
        </p>
        <p v-for="(account) in accounts" class="letter-content">
            <strong>
                {{ account.furnisher_name }} with account number {{ account.account_number }}
            </strong>
            <template v-if="account.reason">
                <br />
                {{ account.reason }}
            </template>
        </p>
        <ul>
            <li class="letter-content">
                Agreement with the original creditor that authorizes you to collect on this alleged debt and/or verification that this alleged debt was assigned or sold to you.                            <br>
            </li>
            <li class="letter-content">
                The agreement bearing my signature stating that I have agreed to assume the debt
                <br>
            </li>
            <li class="letter-content">
                Valid copies of the debt agreement stating the amount of the debt and interest charges<br>
            </li>
            <li class="letter-content">
                Proof that the Statute of Limitations in (Your State) has not expired
                <br>
            </li>

            <li class="letter-content">
                Complete payment history on this account along with an accounting of all additional charges being assessed
                <br>
            </li>
            <li class="letter-content">
                Proof that you are licensed to collect in my state; and
                <br>
            </li>
            <li class="letter-content">
                Your license numbers and Registered Agent or Agent of Service.
                <br>
            </li>

        </ul>
        <p class="letter-content">
            If your office fails to reply to this debt validation letter within 30 days from the date of your receipt, all instances
            related to this account – if any exist – must be immediately deleted and completely removed from my credit file.
            Moreover, all future attempts to collect on the said debt must be ceased.
        </p>
        <p class="letter-content">
            This will also serve as your legal notice under the federal Fair Debt Collection Practices Act (FDCPA), to cease all
            communication with me concerning the alleged debt referenced above. Do not contact me, members of my family, employers,
            or any other third parties regarding this debt.
        </p>
        <p class="letter-content">
            This includes all communication by telephone or electronic communications, such as email or texts made by your company,
            representatives, or agents. If your offices, representatives, or agents attempt communication with me, members of my
            family, employers, or any other third parties, it will be considered harassment and I will bring this matter before a
            judge.
        </p>
        <p class="letter-content">
            All future communications with me MUST be done in writing via USPS and sent to the address noted in this letter.
        </p>
        <p class="letter-content">
            Your non-compliance with my request will also be construed as an absolute waiver of all claims to enforce the debt
            against me and your implied agreement to compensate me for court costs and attorney fees if I am forced to bring this
            matter before a judge.
        </p>
        <p>
            Sincerely,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            },
            originalCreditedDate:{
                type:String
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash,
                moment: moment
            };
        }
    };
</script>
